import * as tslib_1 from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ViewBase } from '@/views/ViewBase';
import ImageUploader from '@/components/ImageUploader.vue';
import { RegisterInput } from '@/lib/service-proxy/RegisterInput';
import { AccountServiceProxy } from '@/lib/service-proxy/AccountServiceProxy';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
var Register = /** @class */ (function (_super) {
    tslib_1.__extends(Register, _super);
    function Register() {
        var _this = _super.call(this) || this;
        _this.registerModel = new RegisterInput();
        _this.loading = false;
        _this.accountService = new AccountServiceProxy();
        return _this;
    }
    Register.prototype.submit = function () {
        // console.log(this.registerModel);
    };
    Register.prototype.sendCaptcha = function () {
    };
    Register = tslib_1.__decorate([
        Component({
            components: {
                ImageUploader: ImageUploader
            }
        })
    ], Register);
    return Register;
}(ViewBase));
export default Register;
